import { Bar } from 'react-chartjs-2';
import { MONTHS } from '@partiu/ui/utils.ts';
import { useTheme } from '@partiu/ui/contexts/ThemeProvider.tsx';
import { CircularProgress } from '@chakra-ui/react';

export const ActivationUsageGraph = ({
  usageMonthlyCount,
  userMonthlyCount,
  height = '30px',
}: {
  usageMonthlyCount: Record<string, any> | undefined;
  userMonthlyCount: Record<string, any> | undefined;
  height?: string;
}) => {
  const { colors } = useTheme();

  if (!usageMonthlyCount || !userMonthlyCount) return <CircularProgress isIndeterminate />;

  return (
    <Bar
      width="100%"
      height={height}
      options={{
        elements: {
          line: {
            tension: 0,
          },
        },
      }}
      data={{
        labels: MONTHS,
        datasets: [
          {
            label: 'Utilização',
            data: Object.values(usageMonthlyCount).slice(1, Object.values(usageMonthlyCount).length),
            borderColor: colors.graphColors[0],
            backgroundColor: colors.graphColors[0],
            borderWidth: 1,
          },
          {
            label: 'Novos Usuários',
            data: Object.values(userMonthlyCount).slice(1, Object.values(userMonthlyCount).length),
            borderColor: colors.graphColors[5],
            backgroundColor: colors.graphColors[5],
            borderWidth: 1,
          },
        ],
      }}
    />
  );
};
